
import React, { Component } from 'react';
import { Modal, Form, Input, Row } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

class ChargebackForm extends Component {

    //回退申请但状态
    chargeback = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["applicationId"] = this.props.applicationId;
            http.post({
                url: '/tradeApplyAgent/chargeback',
                data: values,
                success: (res) => {
                    messager.notify("回退申请单状态成功！");
                    this.props.onCancel();
                    this.props.successCallback(this.props.queryData);
                }
            });
        });

    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                width={400}
                centered={true}
                visible={visible}
                title="回退申请单状态"
                okText="回退"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.chargeback}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Row>
                    <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                        <Form.Item label="回退原因：">
                            {getFieldDecorator('remark', {
                                rules: [
                                    { required: true, message: '回退原因不能为空!' },
                                    { max: 64, message: '回退原因不能超过64个字符！' },
                                ]
                            })(<Input.TextArea />)}
                        </Form.Item>
                    </Form>
                </Row>
            </Modal>
        )
    }
}


const Chargeback = Form.create()(ChargebackForm);

export default Chargeback;